import {useState} from 'react';
import {connect} from 'react-redux';
import {useToasts} from 'react-toast-notifications';
import MobileForm from './mobile-form';
import SMSKeyForm from '../../shared/sms-key-form';
import ErrorMessage from '../../shared/error-message';
import {sendSMSKeyRequest, updateMobileRequest} from '../../../redux/actions/user';

function UpdateMobile(props) {
  const [step, setStep] = useState(0);
  const [mobile, setMobile] = useState(null);
  const [validator, setValidator] = useState(null);
  const [error, setError] = useState(null);

  const {addToast} = useToasts();

  if (error) return (<ErrorMessage message={error}/>);

  if (step === MOBILE)
    return (
      <MobileForm
        onSubmit={async function (mobile) {
          const {payload: {validator}} = await props.sendSMSKeyRequest(mobile);
          setMobile(mobile);
          setValidator(validator);
          setStep(SMS_KEY);
        }}
        onError={setError}
      />
    );

  if (step === SMS_KEY)
    return (
      <SMSKeyForm
        mobile={mobile}
        onSubmit={async function (smsKey) {
          await props.updateMobileRequest(mobile, smsKey, validator);
          addToast('شماره تلفن همراه با موفقیت تغییر کرد.', {appearance: 'success'});
          setStep(MOBILE);
        }}
        onResend={async function () {
          const {payload: {validator}} = await props.sendSMSKeyRequest(mobile);
          setValidator(validator);
        }}
        onError={setError}
      />
    );

  return null;
}

const [MOBILE, SMS_KEY] = [0, 1];

export default connect(null, {sendSMSKeyRequest, updateMobileRequest})(UpdateMobile);
